// PWA Installation and Push Notification Setup

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Check if browser supports PWA installation
export const isPWAInstallable = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window;
};

// Register service worker
export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker not supported');
    return null;
  }
  
  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    console.log('[PWA] Service Worker registered:', registration);
    return registration;
  } catch (error) {
    console.error('[PWA] Service Worker registration failed:', error);
    return null;
  }
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('Notifications not supported');
    return false;
  }
  
  try {
    const permission = await Notification.requestPermission();
    console.log('[PWA] Notification permission:', permission);
    return permission === 'granted';
  } catch (error) {
    console.error('[PWA] Notification permission error:', error);
    return false;
  }
};

// Subscribe to push notifications
export const subscribeToPush = async (registration) => {
  if (!registration) return null;
  
  try {
    // Get VAPID public key from backend
    const response = await fetch(`${BACKEND_URL}/api/push/vapid-public-key`);
    const { public_key } = await response.json();
    
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key)
    });
    
    console.log('[PWA] Push subscription created:', subscription);
    
    // Send subscription to backend
    await fetch(`${BACKEND_URL}/api/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(subscription.toJSON())
    });
    
    return subscription;
  } catch (error) {
    console.error('[PWA] Push subscription failed:', error);
    return null;
  }
};

// Get existing push subscription
export const getPushSubscription = async (registration) => {
  if (!registration) return null;
  
  try {
    const subscription = await registration.pushManager.getSubscription();
    return subscription;
  } catch (error) {
    console.error('[PWA] Get subscription failed:', error);
    return null;
  }
};

// Helper function to convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Show install prompt
export const showInstallPrompt = (deferredPrompt) => {
  if (!deferredPrompt) return false;
  
  deferredPrompt.prompt();
  deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('[PWA] User accepted install');
    } else {
      console.log('[PWA] User dismissed install');
    }
  });
  
  return true;
};
